import {
  buildWispClient,
  GetPostsResult,
  GetPostResult,
} from "@wisp-cms/client";

export const wisp = buildWispClient({
  blogId: "3d5981b4-b15c-42a3-b3a0-4932b5ee8ee4",
});

export type { GetPostsResult, GetPostResult };
